import { Link } from "react-router";
import {
  LANDING_PAGE_GUTTER,
  LANDING_SORT_OPTIONS,
  LANDING_TYPOGRAPHY,
} from "../constants/landing.constants";
import type { LandingPillSelectOption } from "./LandingPillSelect";
import LandingIcon from "./LandingIcon";
import LandingPillSelect from "./LandingPillSelect";

interface CourseFilterBarProps {
  categoryTitle: string;
  search: string;
  onSearchChange: (value: string) => void;
  ageFilter: string;
  onAgeFilterChange: (value: string) => void;
  ageOptions: LandingPillSelectOption[];
  sortBy: string;
  onSortChange: (value: string) => void;
  onClearAgeFilter: () => void;
}

const SORT_OPTIONS = LANDING_SORT_OPTIONS.map((o) => ({
  label: o.label,
  value: o.value,
}));

export default function CourseFilterBar({
  categoryTitle,
  search,
  onSearchChange,
  ageFilter,
  onAgeFilterChange,
  ageOptions,
  sortBy,
  onSortChange,
  onClearAgeFilter,
}: CourseFilterBarProps) {
  return (
    <div className={`py-6 ${LANDING_PAGE_GUTTER}`}>
      <nav className={LANDING_TYPOGRAPHY.breadcrumb}>
        <Link to="/classes" className={LANDING_TYPOGRAPHY.breadcrumbLink}>
          Home
        </Link>
        <span className={`mx-1 ${LANDING_TYPOGRAPHY.breadcrumbLink}`}>/</span>
        <span className={LANDING_TYPOGRAPHY.breadcrumbCurrent}>{categoryTitle}</span>
      </nav>

      <p className={LANDING_TYPOGRAPHY.filterSubtext}>
        Find best class on Music Temple
      </p>

      <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
        <div className="flex min-w-0 flex-1 flex-col gap-3 md:flex-row md:items-center md:gap-4">
          <h2 className={LANDING_TYPOGRAPHY.filterTitle}>
            Search
          </h2>
          <div className="relative min-w-0 flex-1 md:max-w-[520px]">
            <LandingIcon
              name="search"
              className={LANDING_TYPOGRAPHY.filterSearchIcon}
            />
            <input
              type="search"
              value={search}
              onChange={(e) => onSearchChange(e.target.value)}
              aria-label="Search courses"
              className={LANDING_TYPOGRAPHY.filterSearchInput}
            />
          </div>
          {ageOptions.length > 0 ? (
            ageFilter ? (
              <span className="inline-flex h-[38px] md:h-[44px] shrink-0 items-center gap-2 rounded-full border border-landing-input bg-white pl-4 pr-3 text-[14px] font-medium text-landing-text">
                {ageFilter}
                <button
                  type="button"
                  onClick={onClearAgeFilter}
                  aria-label="Clear age filter"
                  className="inline-flex shrink-0 items-center justify-center text-landing-text hover:opacity-70"
                >
                  <LandingIcon name="x" className="h-4 w-4" />
                </button>
              </span>
            ) : (
              <LandingPillSelect
                value={ageFilter}
                options={ageOptions}
                placeholder="Level 3"
                onChange={onAgeFilterChange}
                icon="chevron"
                className="w-full md:w-[160px]"
              />
            )
          ) : null}
        </div>

        <LandingPillSelect
          value={sortBy}
          options={SORT_OPTIONS}
          placeholder="Sort by"
          onChange={onSortChange}
          icon="sort"
          showPlaceholderOnTrigger
          className="hidden w-full md:ml-4 md:block md:w-[140px]"
        />
      </div>
    </div>
  );
}
